import React from "react"
import PropTypes from "prop-types"
import Media from "react-media"

// components
import {Fixed} from "../controls/"
import {Cookies} from "../shared"
// import {ScrollProvider} from "../../context/ScrollContext"

// styling
import "./Block.scss"

// TODO use spread operator to pass on properties

function Block(props) {
  if(props.sidebar) {
    return (
      <BlockWithSidebar {...props}>
        {props.children}
      </BlockWithSidebar>
    )
    /*
    return (
      <ScrollProvider>
        <BlockWithSidebar {...props}>
          {props.children}
        </BlockWithSidebar>
      </ScrollProvider>
    )
    */
  }
  else {
    return (
      <BlockWithoutSidebar {...props}>
        {props.children}
      </BlockWithoutSidebar>
    ) 
    /*
    return (
      <BlockWithoutSidebar 
        console={props.console} 
        heading={props.heading} 
        renderAfter={props.renderAfter}>
          {props.children}
      </BlockWithoutSidebar>
    ) 
    */
  }
}

function BlockWithSidebar(props) {
  let consoleInMain = null

  if(props.console && props.showConsoleInMain) {
    consoleInMain = (
      <div className="c-block-main-console">
        {props.console}
      </div>
    )
  }

  return (
    <Media queries={{
      large: "(min-width: 960px)"
    }}>
      {
        matches => {
          if(matches.large) {
            let heading = null
            if(props.heading) {
              heading = (
                <div className="c-block">
                  <div className={`c-block-inner`}>{props.heading}</div>
                </div>
              )
            }
            return (
              <>
              {heading}
              <div className={`c-block ${props.className || ''}`}>
                <div className={`c-block-inner with-sidebar ${props.sidebarPosition || "left"}`}>
                  <div className="c-block-sidebar">
                    {props.sidebar}
                  </div>
                  <div className="c-block-main">
                    {props.children}
                    {consoleInMain}
                  </div>
                </div>
              </div>
              <Cookies size="large" />
              </>
            )
          }
          else {
            return <BlockWithoutSidebar {...props}>{props.children}</BlockWithoutSidebar>
          }
        }
      }
    </Media>
  )
}

function BlockWithoutSidebar(props) {
  let fixed = null
  
  if(props.console) {
    fixed = (
      <Fixed position="bottom">
        {props.console}
        <Cookies size="small" />
      </Fixed>
    )
  }
  let after = null
  if(props.renderAfter) {
    after = props.renderAfter("mobile")
  }
  return (
    <>
    <div className={`c-block ${props.className || ''}`}>
      <div id={props.id || null} className="c-block-inner">
        {props.heading || null}
        {props.children}
        {props.showConsoleInMain ? props.console : null}
        {after}
      </div>
    </div>
    {fixed}
    </>
  )
}

Block.propTypes = {
  sidebar:PropTypes.any,
  sidebarPosition:PropTypes.oneOf(["left", "right"]).isRequired,
  console:PropTypes.any,
  showConsoleInMain:PropTypes.bool,
  renderAfter:PropTypes.func, // (mode) => {} ... mode is either 'desktop' or 'mobile'
  className:PropTypes.string
}

Block.defaultProps = {
  showConsoleInMain:false,
  sidebarPosition:"left"
}

export default Block